module.exports = __webpack_public_path__ + "static/media/trash.f649d886.svg";